// utils
import axios from "src/utils/axios";
import apiSlice from "src/utils/api-slice";
import { setURLParams } from "src/utils/url-query";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    getPickup: "/shipment/pickup/list",
    // USPS
    getPickupUSPSAvailable: "/shipment/get_for_pickup",
    getPickupUSPSPackageLocation: "/shipment/pickup/package/location/list",
    // UPS
    getPickupUPSPackageLocation: "/shipment/pickup/package/location/ups/list",
    getPickupUPSRate: "/shipment/pickup/rate",
    //
    addPickup: "/shipment/pickup/add_by_shipment",
    cancelPickup: "/shipment/pickup/cancel"
};

// ----------------------------------------------------------------------

const getPickupUPSRate = (request) => axios.post(`${ API_ENDPOINTS.getPickupUPSRate }`, { ...request });

// ----------------------------------------------------------------------

const {
    useGetPickupListQuery,
    // USPS
    useGetPickupUSPSAvailableListQuery,
    useGetPickupUSPSPackageLocationListQuery,
    // UPS
    useGetPickupUPSPackageLocationListQuery,
    //
    useAddPickupMutation,
    useCancelPickupMutation
} = apiSlice.injectEndpoints({
    endpoints: builder => ( {
        getPickupList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "PickupList" ],
            query: (request) => `${ API_ENDPOINTS.getPickup }${ setURLParams(request) }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        // USPS
        getPickupUSPSAvailableList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "PickupUSPSAvailableList" ],
            query: () => `${ API_ENDPOINTS.getPickupUSPSAvailable }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        //
        getPickupUSPSPackageLocationList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "PickupUSPSPackageLocationList" ],
            query: () => `${ API_ENDPOINTS.getPickupUSPSPackageLocation }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        // UPS
        getPickupUPSPackageLocationList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "PickupUPSPackageLocationList" ],
            query: () => `${ API_ENDPOINTS.getPickupUPSPackageLocation }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        //
        addPickup: builder.mutation({
            query: (request) => ( {
                url: `${ API_ENDPOINTS.addPickup }`,
                method: "POST",
                body: request
            } ),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    if (
                        error?.error?.status === 400 &&
                        error?.error?.data?.code === "common.shipment.pickup_send_email_fail"
                    ) {
                        dispatch(apiSlice.util.invalidateTags([ "PickupList", "PickupUSPSAvailableList" ]));
                    }
                }
            },
            transformResponse: ({ data }, meta, arg) => data,
            invalidatesTags: [ "PickupList", "PickupUSPSAvailableList" ]
        }),
        cancelPickup: builder.mutation({
            query: (request) => ( {
                url: `${ API_ENDPOINTS.cancelPickup }${ setURLParams(request) }`,
                method: "POST"
            } ),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    if (
                        error?.error?.status === 400 &&
                        error?.error?.data?.code === "common.shipment.pickup_send_email_fail"
                    ) {
                        dispatch(apiSlice.util.invalidateTags([ "PickupList", "PickupUSPSAvailableList" ]));
                    }
                }
            },
            transformResponse: ({ data }, meta, arg) => data,
            invalidatesTags: [ "PickupList", "PickupUSPSAvailableList" ]
        })
    } ),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    useGetPickupListQuery,
    //
    useGetPickupUSPSAvailableListQuery,
    useGetPickupUSPSPackageLocationListQuery,
    //
    useGetPickupUPSPackageLocationListQuery,
    //
    useAddPickupMutation,
    useCancelPickupMutation,
    //
    getPickupUPSRate as getPickupUPSRateAPI
};
